export const CONSUMER_INSIGHTS_FETCH_REQUEST_V2 = 'CONSUMER_INSIGHTS_FETCH_REQUEST_V2';
export const CONSUMER_INSIGHTS_FETCH_SUCCESS_V2 = 'CONSUMER_INSIGHTS_FETCH_SUCCESS_V2';
export const CONSUMER_INSIGHTS_FETCH_FAILURE_V2 = 'CONSUMER_INSIGHTS_FETCH_FAILURE_V2';
